import React from "react";

export default function Superscript({ path, index }) {
  return (
    <sup>
      <a
        href={path}
        target="_blank"
        rel="noreferrer"
        className="text-inherit font-inherit"
      >
        [{index}]
      </a>
    </sup>
  );
}
